import React, { useState } from "react";
import { Link } from "react-router-dom";
import { triggerGAEvent, awsUrl } from "../../../helpers";
import { useEscape } from "../../../hooks/useEscape";
import PropTypes from "prop-types";

import { useUserContext } from "../../../context/UserContext";

const UnlockedPortalNav = ({ bgColorClass, gaPrefix }) => {
  const [navVisible, setNavVisible] = useState(false);
  const { setFromPortal } = useUserContext();

  useEscape(() => setNavVisible(false));

  const navLinks = [
    {
      CTA: "Paradise Plaza",
      icon: `${awsUrl}/media/portals/welcome/icon-updated.svg`,
      height: "h-[40px]",
      href: "/portals/paradise-plaza",
      gaEvent: `${gaPrefix}_nav_t_paradise-plaza`
    },
    {
      CTA: "Calypso Lagoon",
      icon: `${awsUrl}/media/portals/adult-friendly/icon.svg`,
      href: "/portals/calypso-lagoon",
      height: "h-[42px]",
      gaEvent: `${gaPrefix}_nav_t_calypso-lagoon`
    },
    {
      CTA: "Lokono Cove",
      icon: `${awsUrl}/media/portals/retail/icon.svg`,
      href: "/portals/lokono-cove",
      height: "w-[45px]",
      gaEvent: `${gaPrefix}_nav_t_retail`
    },
    {
      CTA: "Starfish Lagoon",
      icon: `${awsUrl}/media/portals/family-friendly/icon.svg`,
      href: "/portals/starfish-lagoon",
      height: "w-[43px]",
      gaEvent: `${gaPrefix}_nav_t_family-friendly`
    }
  ];

  return (
    <nav
      className={`fixed z-[50] w-full h-[55px] flex justify-center items-center ${bgColorClass} -mt-[55px]`}
    >
      <div className="container mx-auto px-4 text-white flex justify-between items-baseline">
        <Link
          tabIndex={0}
          to={`/#section-portals`}
          className="flex items-center"
          onClick={() => {
            setNavVisible(true);
            setFromPortal(true);
            triggerGAEvent(`${gaPrefix}_nav_t_home`);
          }}
        >
          <div className="w-[35px] h-[35px] mb-2 self-center">
            {" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-full h-full"
            >
              <path d="M11.47 3.841a.75.75 0 0 1 1.06 0l8.69 8.69a.75.75 0 1 0 1.06-1.061l-8.689-8.69a2.25 2.25 0 0 0-3.182 0l-8.69 8.69a.75.75 0 1 0 1.061 1.06l8.69-8.689Z" />
              <path d="m12 5.432 8.159 8.159c.03.03.06.058.091.086v6.198c0 1.035-.84 1.875-1.875 1.875H15a.75.75 0 0 1-.75-.75v-4.5a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75V21a.75.75 0 0 1-.75.75H5.625a1.875 1.875 0 0 1-1.875-1.875v-6.198a2.29 2.29 0 0 0 .091-.086L12 5.432Z" />
            </svg>
          </div>
          <span className="uppercase ml-1 text-sm font-bold ">Home</span>
        </Link>
        <div
          className="w-[28px] h-[28px] self-center"
          role="button"
          aria-label="view nav"
          onClick={() => setNavVisible(true)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-[28px] h-[28px]"
          >
            <path
              fillRule="evenodd"
              d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>
      {navVisible && (
        <div className="w-[260px] bg-white absolute right-0  top-0  z-[20]">
          {" "}
          <div
            onClick={() => {
              setNavVisible(false);
            }}
            className="absolute right-2 top-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="w-6 h-6"
            >
              <path
                fillRule="evenodd"
                d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z"
                clipRule="evenodd"
              />
            </svg>
          </div>
          <ul className="mt-10 text-millik">
            {navLinks.map((link, idx) => (
              <li className="py-2 px-3 grid grid-cols-4">
                <img
                  className={`${link.height} inline-block mr-2 `}
                  src={link.icon}
                  alt="icon"
                  aria-hidden="true"
                />
                <Link
                  to={link.href}
                  className={
                    window.location.pathname === link.href
                      ? `font-bold col-span-3 self-center hover:font-bold`
                      : `col-span-3 self-center hover:font-bold`
                  }
                  onClick={() => {
                    setNavVisible(false);
                    triggerGAEvent(link.gaEvent);
                  }}
                >
                  {link.CTA}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </nav>
  );
};

UnlockedPortalNav.propTypes = {
  bgColorClass: PropTypes.string.isRequired
};

export default UnlockedPortalNav;
